module.exports = __webpack_public_path__ + "static/media/spd.80a51921.svg";